/* src/app/depot-stock-location/pages/depot-stock-locations-new/depot-stock-locations-new.component.scss */
/*# sourceMappingURL=depot-stock-locations-new.component.css.map */
